"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BillingOrderType = void 0;
var BillingOrderType;
(function (BillingOrderType) {
    BillingOrderType["FLEXPORT_SHIPPING"] = "Flexport Shipping";
    BillingOrderType["RETAILER_DROPSHIP"] = "Dropshipping - Retailer Carrier Account";
    BillingOrderType["THIRD_PARTY_DROPSHIP"] = "Dropshipping - Seller Carrier Account";
    BillingOrderType["SHIP_TO_STORE"] = "Ship to Store";
    BillingOrderType["B2B_SINGLE_POOL"] = "B2B Single Pool";
    BillingOrderType["B2B_DROPSHIP"] = "Dropshipping - B2B";
})(BillingOrderType || (exports.BillingOrderType = BillingOrderType = {}));
//# sourceMappingURL=BillingOrderType.js.map